import React from "react";
import { Icon , IconProps } from "@chakra-ui/react";

const EditSquareIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 25" width="24px" height="25px" fill="none" {...props}>
    <g id="Icon / edit_square">
      <mask
        id="mask0_15602_43964"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect id="Bounding box" y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15602_43964)">
        <path
          id="edit_square"
          d="M5 21.5001C4.45 21.5001 3.97917 21.3043 3.5875 20.9126C3.19583 20.5209 3 20.0501 3 19.5001V5.5001C3 4.9501 3.19583 4.47926 3.5875 4.0876C3.97917 3.69593 4.45 3.5001 5 3.5001H13.925L11.925 5.5001H5V19.5001H19V12.5501L21 10.5501V19.5001C21 20.0501 20.8042 20.5209 20.4125 20.9126C20.0208 21.3043 19.55 21.5001 19 21.5001H5ZM9 15.5001V11.2501L18.175 2.0751C18.375 1.8751 18.6 1.7251 18.85 1.6251C19.1 1.5251 19.35 1.4751 19.6 1.4751C19.8667 1.4751 20.1208 1.5251 20.3625 1.6251C20.6042 1.7251 20.825 1.8751 21.025 2.0751L22.425 3.5001C22.6083 3.7001 22.75 3.92093 22.85 4.1626C22.95 4.40426 23 4.6501 23 4.9001C23 5.1501 22.9542 5.39593 22.8625 5.6376C22.7708 5.87926 22.625 6.1001 22.425 6.3001L13.25 15.5001H9ZM11 13.5001H12.4L18.2 7.7001L17.5 7.0001L16.775 6.3001L11 12.0751V13.5001Z"
          fill="#3CAA91"
        />
      </g>
    </g>
  </Icon>
);
export default EditSquareIcon;
